import { render, staticRenderFns } from "./unpublished.vue?vue&type=template&id=4b725080&scoped=true&"
import script from "./unpublished.vue?vue&type=script&lang=js&"
export * from "./unpublished.vue?vue&type=script&lang=js&"
import style0 from "./unpublished.vue?vue&type=style&index=0&id=4b725080&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b725080",
  null
  
)

export default component.exports